import { render, staticRenderFns } from "./manifest-order.vue?vue&type=template&id=657e7e29"
import script from "./manifest-order.vue?vue&type=script&lang=js"
export * from "./manifest-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports